import React , { useState, useEffect } from 'react';
import {useParams} from 'react-router-dom';
import './carteira.css';
import firebase from '../Config/firebase.js';
import { collection, doc, getDoc, getFirestore, setDoc } from 'firebase/firestore';

function Carteira(props){

    const [nome,setNome] = useState('');
    const [siape,setSiape] = useState('');
    const params = useParams();
    const db = getFirestore();
    var cartnome = params.id;
    var subcpf = cartnome.substring(0,11);
    var subnome = cartnome.substring(11,40);
    var cartdat = Date();

    return <section id="carteira">
                <div className="row">                    
                       <div className="col-lg-4">
                       <img src="/images/Carteira4.jpeg" className="imgcart"/>
                       <img src="/images/Ficti.png" className="imgfoto"/>
                       <h1 className='h1cart'> {subnome} </h1>
                       <h1 className='h1cart2'> CPF: {subcpf} </h1>
                       <h1 className='h1cart3'> SINDICALIZADO </h1>
                       </div>           
                </div>
            </section>
           
  }

  export default Carteira;